// src/utils/eventBus.js
import { reactive } from 'vue';

const eventBus = reactive({});  // 使用 `reactive` 来使其成为响应式对象

eventBus.$on = function (event, callback) {
    if (!this[event]) {
        this[event] = [];
    }
    this[event].push(callback);
};

eventBus.$emit = function (event, data) {
    if (this[event]) {
        this[event].forEach(callback => callback(data));
    }
};

eventBus.$off = function (event, callback) {
    if (!this[event]) return;
    this[event] = this[event].filter(fn => fn !== callback);
};

export default eventBus;
